module.exports = __webpack_public_path__ + "img/banner-bg.643d2050.jpg";